
<template>
  <financeapproval-component>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>Finance Approval</strong>
          
          </div>
          <div id="overlay" >
             <div class="loader"></div>
           </div>

      <!-- Filter  -->
      <b-row>
      <b-col md="12">
        <b-col md="12">  
        <b-row class="form-group">    
                <b-col sm="3" >
                 
              <b-form-group label="DeliveryAgent">
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select>
               </b-form-group>
                </b-col> 
                <b-col sm="3">
                         
                <b-form-group label="From Date"   >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>

              </b-col>
               <b-col sm="3">
               
                <b-form-group label="To Date"   >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>

              </b-col>
              <b-col sm="2" >     
               <b-button type="submit" size="md" variant="primary" @click="petrolBillappFinancelist()" style="margin-top: 19%;"> Search</b-button>
              </b-col>
            </b-row>
            </b-col>
          </b-col>     
        </b-row>

         <!-- Filter End -->
          <b-col sm="12" class="text-right">

                <b-button v-if="totalRows>0" @click="downloadCSV('Approved')"   type="submit" style="margin-right: 10px;margin-bottom:5px;" variant="primary" size="md" >Download </b-button>

               <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
              </b-col> 
          <b-col sm="12">


             <b-table responsive show-empty  :busy="isBusy" :items="finApproveitems" :fields="finApprovefields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

             <template slot="receiptno" slot-scope="row">
               <div class="cdm_table">
                {{row.item.receiptno}}
             
            <span  v-if="row.item.receipturl !='undefined' &&row.item.receipturl !=null && row.item.receipturl !=''"  data-toggle="tooltip"   @click="reciptImagemodal(row.item)"> 
               <i class="fa fa-file-image-o" aria-hidden="true" data-toggle="tooltip" title="View Image" style="color:  #20a8d8;float:right;cursor:pointer "></i></span>

                   
                 
              </div>

            </template>
             <template slot="actions" slot-scope="row">
                  <!-- <b-button size="sm" data-toggle="tooltip" @click="feedbackmodal()" title="Give Feedback" class="mr-1">
                  <i class="fa fa-comments-o" aria-hidden="true"></i>
                  </b-button> -->
                  <span style="cursor:pointer;">
                     <span data-toggle="tooltip" title="Give Feedback">
                    <span @click="feedbackmodal()" class="badge badge-info" style="font-size: 12px; color:white;">Feedback</span>
                  </span>
                  </span>

                  <span   style="cursor:pointer;">
                    <span data-toggle="tooltip" title="Approve">
                    <span  @click="approvetoggleInfoModal()" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Approve</span>
                  </span>
                  <span  data-toggle="tooltip" title="Reject"> 
                    <span @click="rejecttoggleInfoModal()" class="badge badge-danger" style="margin-left: 5px;
    font-size: 12px;">Reject</span>
                  </span>  
                  </span>

              </template>


          </b-table>
        </b-col>
          <b-col md="6" class="my-1" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>

           <!-- Receipt Image Modal -->
         <b-modal v-model="receiptimage" @ok=" receiptimage= false"  title="Receipt Image" hide-footer>
                   <div class="d-block text-center" >
                      <img alt="This image is not available" style="width: 460px;height: 260px;" 
                      v-bind:src="receiptImgpath">  
                    </div>
                     <div>

                      <a :href="receiptImgpath" target="_blank"> <i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Download Recipt" style="color: ##20a8d8;float:right;margin-top:5px;margin-right: 5px;font-size:25px "></i></a> 
                    </div>
    
                </b-modal>

                  <!-- Receipt Image Modal End -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</financeapproval-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';

export default {
  data: function() {
    return {
      
      
      finApproveitems:[],
      finApprovefields:[
      { key: 'rider_name', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
        { key: 'deposite_amount', label: 'Deposited Amount', sortable: true, sortDirection: 'desc' },
          
          // { key: 'pendingcodcollectable', label: 'Pending Amount', sortable: true, sortDirection: 'desc' },
        { key: 'requested_date', label: 'Requested Date', sortable: true, sortDirection: 'desc' },
        { key: 'fuel_filling_date', label: 'Fuel Filling Date', sortable: true, sortDirection: 'desc' },
         { key: 'bill_type', label: 'Bill Type', sortable: true, sortDirection: 'desc' },
         { key: 'receiptno', label: 'Receipt No', sortable: true, sortDirection: 'desc' },
         { key: 'expense_type', label: 'Expense Type', sortable: true, sortDirection: 'desc' },
         { key: 'payment_mode', label: 'Payment Mode', sortable: true, sortDirection: 'desc' },
         { key: 'created_by', label: 'Approved By', sortable: true, sortDirection: 'desc' },
         { key: 'city', label: 'City', sortable: true, sortDirection: 'desc' },
        
          { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc' },
          // { key: 'feedback', label: 'Feedback Msg', sortable: true, sortDirection: 'desc' },
      ],
        selected:'',
        isBusy: false,
        
        Pickup:'',
        email:'',
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        agentmaster:[],
        selectDateFrom:new Date(),
        selectDateTo:new Date(),
        deliveryagentid:'',
         receiptimage:false,
         receiptImgpath:'',
        
        
        
    };
  },
   



  computed: {
    sortOptions() {
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.displaydata();
    this.petrolBillappFinancelist();
  },
  methods: {

       // Function for DeliveryAgent dropdown
  
     displaydata: function () {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          // console.log("agentmaster",this.agentmaster);
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // end
         // Pending For Finance Listing
   petrolBillappFinancelist:function(){
           
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // console.log("this.deliveryagentid",typeof this.deliveryagentid);
        var deliveryagentid=(this.deliveryagentid!='')? this.deliveryagentid:null;
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // this.selected_status=status;
     
      this.isBusy = true;
         
     
      const obj = {
    
        deliveryagentmasterid:deliveryagentid,
        fromdate:fromdate,
        todate:formatdateto,
        status: 'Approved',
        
         created_by:`${userInfo.sysemailid}`,
         hub_id:`${userInfo.pickuplocationmasterid}`,
         is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
       
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCdmDepositeDetailsForPetrolBill`,obj)
        .then(result => {
          this.isBusy=false;
          if (result.data.returnmsg == "Successful") {

            this.finApproveitems  = result.body.returnvalue;
            // this.imgpath=result.body.returnvalue;
           
            this.totalRows = result.body.returnvalue.length
          
          } else {
             this.finApproveitems=[];
             this.totalRows=0;
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });

   },

    // Receipt Image modal Function

  reciptImagemodal(value) {
        // this.$refs['my-modal'].show();
        this.receiptimage=true;
        this.receiptImgpath=value.receipturl;
        // console.log("urllll", this.receiptImgpath);

      },

      // end

      downloadCSV: function(status) {
  // alert("status");
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
       var deliveryagentid=(this.deliveryagentid!='')? this.deliveryagentid:null;
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      this.selected_status=status;
      
          const csvObj = {
          deliveryagentmasterid:deliveryagentid,
          fromdate:fromdate,
          todate:formatdateto,
          status: status,
          created_by:`${userInfo.sysemailid}`,
          sysusermasterid:`${userInfo.sysusermasterid}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
          };
          console.log("csvobj",csvObj);
          // return false;
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCdmDepositeForPetroBillcsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         // alert("Please Check Your Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
          this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }
        
        });
        
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    }, 

    
   

    

   
  
    
  }
};
</script>

<style lang="css">

</style>
